// REACT
import React from "react";

// REDUX
import { useDispatch, useSelector } from "react-redux";

// REACT ROUTER
import { useParams } from "react-router-dom";

// STORE ACTIONS
import { editApplication } from "store/actions";

// COMPONENTS
import Form from "components/Form";
import FormWrapper from "components/Form/form-wrapper";
import InputsGroup from "components/Form/inputs-group";
import SaveChangesButton from "components/Form/save-changes-button";

const AppSnippets = () => {
    const { singleApplication } = useSelector((state) => state.applications);
    const dispatch = useDispatch();
    const { applicationId } = useParams();
    let defaultValues = {
        appSnippets: singleApplication?.appSnippets || [],
    };

    const onSubmitSnippets = (data) => {
        dispatch(
            editApplication({
                endpointName: "snippets",
                id: applicationId,
                data,
            })
        );
    };

    return (
        <FormWrapper>
            <Form onSubmit={onSubmitSnippets} defaultValues={defaultValues}>
                <div className="app-snippets">
                    <InputsGroup
                        name="appSnippets"
                        title="snippet"
                        inputs={[
                            {
                                name: "name",
                                type: "text",
                            },
                            {
                                name: "position",
                                type: "select",
                                id: "1",
                                placholder: "choose position",
                                hasLocales: false,
                                options: [
                                    { value: "body", label: "<body>" },
                                    { value: "head", label: "<head>" },
                                ],
                                rules: { required: false },
                            },
                            {
                                name: "snippet",
                                type: "code",
                            },
                        ]}
                    />
                    <SaveChangesButton />
                </div>
            </Form>
        </FormWrapper>
    );
};

export default AppSnippets;
